<button
  id="close-footbar"
  type="button"
  class="close"
  aria-label="Close"
  [mat-dialog-close]="false">
  <span aria-hidden="true">×</span>
</button>
<h2 mat-dialog-title>{{ 'k002587' | translate }}</h2>
<mat-dialog-content class="content">
<div><span>{{ 'k002573' | translate }}</span></div>
</mat-dialog-content>
